webpackJsonp([5],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModuleNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_containers_app_app_component__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_app_app_component_ngfactory__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angularfire2_app_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angularfire2_angularfire2__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angularfire2_auth_auth__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angularfire2_auth_auth_module__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angularfire2_database_database__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angularfire2_database_database_module__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__angular_forms__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__angular_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_health_shared_services_meals_meals_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_health_shared_services_workouts_workouts_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_health_shared_services_schedule_schedule_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_auth_shared_shared_module__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_auth_auth_module__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_health_shared_shared_module__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_health_health_module__ = __webpack_require__(137);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

























var AppModuleNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵcmf */](__WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], [__WEBPACK_IMPORTED_MODULE_2__src_app_containers_app_app_component__["a" /* AppComponent */]], function (_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_28" /* ɵmod */]([__WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* ComponentFactoryResolver */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_9" /* ɵCodegenComponentFactoryResolver */], [[8, [__WEBPACK_IMPORTED_MODULE_3__containers_app_app_component_ngfactory__["a" /* AppComponentNgFactory */]]], [3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* ComponentFactoryResolver */]], __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* NgModuleRef */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* LOCALE_ID */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵm */], [[3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* LOCALE_ID */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_4__angular_common__["m" /* NgLocalization */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["l" /* NgLocaleLocalization */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* LOCALE_ID */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* APP_ID */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_18" /* ɵf */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* IterableDiffers */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵk */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* KeyValueDiffers */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵl */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["b" /* DomSanitizer */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["s" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Q" /* Sanitizer */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["b" /* DomSanitizer */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["e" /* HAMMER_GESTURE_CONFIG */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["f" /* HammerGestureConfig */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["c" /* EVENT_MANAGER_PLUGINS */], function (p0_0, p1_0, p2_0, p2_1) {
            return [new __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["k" /* ɵDomEventsPlugin */](p0_0), new __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["o" /* ɵKeyEventsPlugin */](p1_0), new __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["n" /* ɵHammerGesturesPlugin */](p2_0, p2_1)];
        }, [__WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["e" /* HAMMER_GESTURE_CONFIG */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["d" /* EventManager */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["d" /* EventManager */], [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["c" /* EVENT_MANAGER_PLUGINS */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["G" /* NgZone */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](135680, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["m" /* ɵDomSharedStylesHost */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["m" /* ɵDomSharedStylesHost */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["l" /* ɵDomRendererFactory2 */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["l" /* ɵDomRendererFactory2 */], [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["d" /* EventManager */],
            __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["m" /* ɵDomSharedStylesHost */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_0__angular_core__["O" /* RendererFactory2 */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["l" /* ɵDomRendererFactory2 */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["p" /* ɵSharedStylesHost */], null, [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["m" /* ɵDomSharedStylesHost */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Testability */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Testability */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["G" /* NgZone */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["g" /* Meta */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["g" /* Meta */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["i" /* Title */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["i" /* Title */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* DOCUMENT */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__["a" /* FirebaseApp */], __WEBPACK_IMPORTED_MODULE_7_angularfire2_app_index__["c" /* _firebaseAppFactory */], [__WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__["b" /* FirebaseAppConfigToken */], __WEBPACK_IMPORTED_MODULE_8_angularfire2_angularfire2__["c" /* FirebaseAppName */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_9_angularfire2_auth_auth__["a" /* AngularFireAuth */], __WEBPACK_IMPORTED_MODULE_10_angularfire2_auth_auth_module__["b" /* _getAngularFireAuth */], [__WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__["a" /* FirebaseApp */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_11_angularfire2_database_database__["a" /* AngularFireDatabase */], __WEBPACK_IMPORTED_MODULE_12_angularfire2_database_database_module__["b" /* _getAngularFireDatabase */], [__WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__["a" /* FirebaseApp */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_13__angular_forms__["e" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_13__angular_forms__["e" /* FormBuilder */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_13__angular_forms__["s" /* ɵi */], __WEBPACK_IMPORTED_MODULE_13__angular_forms__["s" /* ɵi */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */], __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */], [__WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_9_angularfire2_auth_auth__["a" /* AngularFireAuth */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__["a" /* AuthGuard */], __WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__["a" /* AuthGuard */], [__WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_18__src_health_shared_services_meals_meals_service__["a" /* MealsService */], __WEBPACK_IMPORTED_MODULE_18__src_health_shared_services_meals_meals_service__["a" /* MealsService */], [__WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_11_angularfire2_database_database__["a" /* AngularFireDatabase */], __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_19__src_health_shared_services_workouts_workouts_service__["a" /* WorkoutsService */], __WEBPACK_IMPORTED_MODULE_19__src_health_shared_services_workouts_workouts_service__["a" /* WorkoutsService */], [__WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_11_angularfire2_database_database__["a" /* AngularFireDatabase */],
            __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_20__src_health_shared_services_schedule_schedule_service__["a" /* ScheduleService */], __WEBPACK_IMPORTED_MODULE_20__src_health_shared_services_schedule_schedule_service__["a" /* ScheduleService */], [__WEBPACK_IMPORTED_MODULE_14__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_15__src_auth_shared_services_auth_auth_service__["a" /* AuthService */], __WEBPACK_IMPORTED_MODULE_11_angularfire2_database_database__["a" /* AngularFireDatabase */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_17__angular_router__["a" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["x" /* ɵf */], [__WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_17__angular_router__["d" /* NoPreloading */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["d" /* NoPreloading */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_17__angular_router__["f" /* PreloadingStrategy */], null, [__WEBPACK_IMPORTED_MODULE_17__angular_router__["d" /* NoPreloading */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](135680, __WEBPACK_IMPORTED_MODULE_17__angular_router__["p" /* RouterPreloader */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["p" /* RouterPreloader */], [__WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["D" /* NgModuleFactoryLoader */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* Injector */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["f" /* PreloadingStrategy */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_17__angular_router__["e" /* PreloadAllModules */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["e" /* PreloadAllModules */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_17__angular_router__["h" /* ROUTER_INITIALIZER */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["A" /* ɵi */], [__WEBPACK_IMPORTED_MODULE_17__angular_router__["y" /* ɵg */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["b" /* APP_BOOTSTRAP_LISTENER */], function (p0_0) {
            return [p0_0];
        }, [__WEBPACK_IMPORTED_MODULE_17__angular_router__["h" /* ROUTER_INITIALIZER */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_4__angular_common__["c" /* CommonModule */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["c" /* CommonModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["q" /* ɵa */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* NgProbeToken */], function () {
            return [__WEBPACK_IMPORTED_MODULE_17__angular_router__["t" /* ɵb */]()];
        }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_17__angular_router__["y" /* ɵg */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["y" /* ɵg */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* Injector */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* APP_INITIALIZER */], function (p0_0, p0_1, p1_0) {
            return [__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["r" /* ɵc */](p0_0, p0_1), __WEBPACK_IMPORTED_MODULE_17__angular_router__["z" /* ɵh */](p1_0)];
        }, [[2, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["h" /* NgProbeToken */]], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* NgProbeToken */]], __WEBPACK_IMPORTED_MODULE_17__angular_router__["y" /* ɵg */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ApplicationInitStatus */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ApplicationInitStatus */], [[2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* APP_INITIALIZER */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](131584, __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵe */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["G" /* NgZone */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_10" /* ɵConsole */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* Injector */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* ComponentFactoryResolver */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ApplicationInitStatus */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](2048, __WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* ApplicationRef */], null, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵe */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ApplicationModule */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ApplicationModule */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* ApplicationRef */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["a" /* BrowserModule */], [[3, __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["a" /* BrowserModule */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_17__angular_router__["s" /* ɵa */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["v" /* ɵd */], [[3, __WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_17__angular_router__["r" /* UrlSerializer */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["c" /* DefaultUrlSerializer */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_17__angular_router__["b" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["b" /* ChildrenOutletContexts */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_17__angular_router__["g" /* ROUTER_CONFIGURATION */], {}, []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_4__angular_common__["i" /* LocationStrategy */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["u" /* ɵc */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["o" /* PlatformLocation */], [2, __WEBPACK_IMPORTED_MODULE_4__angular_common__["a" /* APP_BASE_HREF */]],
            __WEBPACK_IMPORTED_MODULE_17__angular_router__["g" /* ROUTER_CONFIGURATION */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_4__angular_common__["h" /* Location */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["h" /* Location */], [__WEBPACK_IMPORTED_MODULE_4__angular_common__["i" /* LocationStrategy */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["D" /* NgModuleFactoryLoader */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["U" /* SystemJsNgModuleLoader */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["V" /* SystemJsNgModuleLoaderConfig */]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_17__angular_router__["i" /* ROUTES */], function () {
            return [[{ path: 'auth', children: [{ path: '', pathMatch: 'full', redirectTo: 'login' },
                            { path: 'login', loadChildren: './login/login.module#LoginModule' }, { path: 'register',
                                loadChildren: './register/register.module#RegisterModule' }] }], [{ path: 'schedule',
                        canActivate: [__WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__["a" /* AuthGuard */]], loadChildren: './schedule/schedule.module#ScheduleModule' },
                    { path: 'meals', canActivate: [__WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__["a" /* AuthGuard */]], loadChildren: './meals/meals.module#MealsModule' },
                    { path: 'workouts', canActivate: [__WEBPACK_IMPORTED_MODULE_16__src_auth_shared_guards_auth_guard__["a" /* AuthGuard */]], loadChildren: './workouts/workouts.module#WorkoutsModule' }],
                [{ path: '', pathMatch: 'full', redirectTo: 'schedule' }]];
        }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["w" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* ApplicationRef */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["r" /* UrlSerializer */],
            __WEBPACK_IMPORTED_MODULE_17__angular_router__["b" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_4__angular_common__["h" /* Location */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* Injector */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["D" /* NgModuleFactoryLoader */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["i" /* ROUTES */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["g" /* ROUTER_CONFIGURATION */], [2, __WEBPACK_IMPORTED_MODULE_17__angular_router__["q" /* UrlHandlingStrategy */]],
            [2, __WEBPACK_IMPORTED_MODULE_17__angular_router__["j" /* RouteReuseStrategy */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_17__angular_router__["n" /* RouterModule */], __WEBPACK_IMPORTED_MODULE_17__angular_router__["n" /* RouterModule */], [[2, __WEBPACK_IMPORTED_MODULE_17__angular_router__["s" /* ɵa */]], [2, __WEBPACK_IMPORTED_MODULE_17__angular_router__["k" /* Router */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_8_angularfire2_angularfire2__["a" /* AngularFireModule */], __WEBPACK_IMPORTED_MODULE_8_angularfire2_angularfire2__["a" /* AngularFireModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_10_angularfire2_auth_auth_module__["a" /* AngularFireAuthModule */], __WEBPACK_IMPORTED_MODULE_10_angularfire2_auth_auth_module__["a" /* AngularFireAuthModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_12_angularfire2_database_database_module__["a" /* AngularFireDatabaseModule */], __WEBPACK_IMPORTED_MODULE_12_angularfire2_database_database_module__["a" /* AngularFireDatabaseModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_13__angular_forms__["p" /* ɵba */], __WEBPACK_IMPORTED_MODULE_13__angular_forms__["p" /* ɵba */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_13__angular_forms__["n" /* ReactiveFormsModule */], __WEBPACK_IMPORTED_MODULE_13__angular_forms__["n" /* ReactiveFormsModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_21__src_auth_shared_shared_module__["a" /* SharedModule */], __WEBPACK_IMPORTED_MODULE_21__src_auth_shared_shared_module__["a" /* SharedModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_22__src_auth_auth_module__["a" /* AuthModule */], __WEBPACK_IMPORTED_MODULE_22__src_auth_auth_module__["a" /* AuthModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_23__src_health_shared_shared_module__["a" /* SharedModule */], __WEBPACK_IMPORTED_MODULE_23__src_health_shared_shared_module__["a" /* SharedModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_24__src_health_health_module__["a" /* HealthModule */], __WEBPACK_IMPORTED_MODULE_24__src_health_health_module__["a" /* HealthModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], __WEBPACK_IMPORTED_MODULE_1__src_app_app_module__["a" /* AppModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_6_angularfire2_app_firebase_app_module__["b" /* FirebaseAppConfigToken */], { apiKey: 'AIzaSyBIr0Mi8enCvavhiT5d-_x8J_NX8xkFAkM', authDomain: 'fitness-app-ua-ffad7.firebaseapp.com',
            databaseURL: 'https://fitness-app-ua-ffad7.firebaseio.com', projectId: 'fitness-app-ua-ffad7',
            storageBucket: 'fitness-app-ua-ffad7.appspot.com', messagingSenderId: '716655804729' }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_8_angularfire2_angularfire2__["c" /* FirebaseAppName */], undefined, [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=
//# sourceMappingURL=app.module.ngfactory.js.map

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROUTES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
// routes
var ROUTES = [
    { path: "", pathMatch: "full", redirectTo: "schedule" }
];
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());

// https://fitness-app-ua-ffad7.firebaseapp.com
// const firebaseConfig = {
//   apiKey: "AIzaSyBIr0Mi8enCvavhiT5d-_x8J_NX8xkFAkM",
//   authDomain: "fitness-app-ua-ffad7.firebaseapp.com",
//   databaseURL: "https://fitness-app-ua-ffad7.firebaseio.com",
//   projectId: "fitness-app-ua-ffad7",
//   storageBucket: "fitness-app-ua-ffad7.appspot.com",
//   messagingSenderId: "716655804729",
//   appId: "1:716655804729:web:b1c2c123573d0d2e90e8e8",
//   measurementId: "G-KJ6V9DJGR9"
// };
//# sourceMappingURL=app.module.js.map

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RenderType_AppComponent */
/* unused harmony export View_AppComponent_0 */
/* unused harmony export View_AppComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_nav_app_nav_component_ngfactory__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_components_app_nav_app_nav_component__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_containers_app_app_component__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_header_app_header_component_ngfactory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_components_app_header_app_header_component__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_common__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_auth_shared_services_auth_auth_service__ = __webpack_require__(4);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_AppComponent = [__WEBPACK_IMPORTED_MODULE_0__app_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AppComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_14" /* ɵcrt */]({ encapsulation: 0, styles: styles_AppComponent,
    data: {} });
function View_AppComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 2, 'app-nav', [], null, null, null, __WEBPACK_IMPORTED_MODULE_2__components_app_nav_app_nav_component_ngfactory__["b" /* View_AppNavComponent_0 */], __WEBPACK_IMPORTED_MODULE_2__components_app_nav_app_nav_component_ngfactory__["a" /* RenderType_AppNavComponent */])),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_components_app_nav_app_nav_component__["a" /* AppNavComponent */], [], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, [' ']))], null, null);
}
function View_AppComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 16, 'div', [], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 3, 'app-header', [], null, [[null, 'logout']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('logout' === en)) {
                    var pd_0 = (_co.onLogout() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, __WEBPACK_IMPORTED_MODULE_5__components_app_header_app_header_component_ngfactory__["b" /* View_AppHeaderComponent_0 */], __WEBPACK_IMPORTED_MODULE_5__components_app_header_app_header_component_ngfactory__["a" /* RenderType_AppHeaderComponent */])), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_6__src_app_components_app_header_app_header_component__["a" /* AppHeaderComponent */], [], { user: [0, 'user'] }, { logout: 'logout' }),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](131072, __WEBPACK_IMPORTED_MODULE_7__angular_common__["b" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]]), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, [' '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_11" /* ɵand */](16777216, null, null, 2, null, View_AppComponent_1)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](16384, null, 0, __WEBPACK_IMPORTED_MODULE_7__angular_common__["k" /* NgIf */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["Z" /* ViewContainerRef */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["W" /* TemplateRef */]], { ngIf: [0, 'ngIf'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_33" /* ɵpid */](131072, __WEBPACK_IMPORTED_MODULE_7__angular_common__["b" /* AsyncPipe */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]]), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 4, 'div', [['class', 'wrapper']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](212992, null, 0, __WEBPACK_IMPORTED_MODULE_8__angular_router__["o" /* RouterOutlet */], [__WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Z" /* ViewContainerRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["k" /* ComponentFactoryResolver */], [8, null], __WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_39" /* ɵunv */](_v, 4, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 5).transform(_co.user$));
        _ck(_v, 4, 0, currVal_0);
        var tmp_1_0 = null;
        var currVal_1 = (((tmp_1_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_39" /* ɵunv */](_v, 9, 0, __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 10).transform(_co.user$))) == null) ? null : tmp_1_0.authenticated);
        _ck(_v, 9, 0, currVal_1);
        _ck(_v, 15, 0);
    }, null);
}
function View_AppComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 1, 'app-root', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](245760, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_containers_app_app_component__["a" /* AppComponent */], [__WEBPACK_IMPORTED_MODULE_9__src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_8__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_10__src_auth_shared_services_auth_auth_service__["a" /* AuthService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AppComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_12" /* ɵccf */]('app-root', __WEBPACK_IMPORTED_MODULE_4__src_app_containers_app_app_component__["a" /* AppComponent */], View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdj5cbiAgICAgIDxhcHAtaGVhZGVyIFt1c2VyXT1cInVzZXIkIHwgYXN5bmNcIiAobG9nb3V0KT1cIm9uTG9nb3V0KClcIj4gPC9hcHAtaGVhZGVyPlxuICAgICAgPGFwcC1uYXYgKm5nSWY9XCIodXNlciQgfCBhc3luYyk/LmF1dGhlbnRpY2F0ZWRcIj4gPC9hcHAtbmF2PlxuXG4gICAgICA8ZGl2IGNsYXNzPVwid3JhcHBlclwiPlxuICAgICAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgIiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDR007TUFBQTthQUFBO1VBQUEsZUFBZ0Q7OztvQkFIdEQsMkNBQ0k7TUFBQTtNQUFBLDhCQUFLLDZDQUNIO2FBQUE7VUFBQTtZQUFBO1lBQUE7WUFBbUM7Y0FBQTtjQUFBO1lBQUE7WUFBbkM7VUFBQSx5RUFBQTtNQUFBO2FBQVksNkNBQTZDO1VBQUEsUUFBYyw2Q0FDdkU7VUFBQSx5RUFBQTtVQUFBO1VBQUEsc0JBQVMsNkNBQWtEO2lCQUFBLGdDQUUzRDtVQUFBO1VBQUEsOEJBQXFCO01BQ25CO1VBQUE7YUFBQTtzQ0FBQTtVQUFBLGVBQStCLDZDQUMzQjtVQUFBLGFBQ0Y7O0lBTlE7SUFBWixXQUFZLFNBQVo7SUFDUztJQUFBO0lBQVQsV0FBUyxTQUFUO0lBR0U7Ozs7b0JDTlI7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=app.component.ngfactory.js.map

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['[_nghost-%COMP%]{width:100%}.wrapper[_ngcontent-%COMP%]{max-width:800px;width:96%;margin:0 auto}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=app.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_AppNavComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_AppNavComponent_0;
/* unused harmony export View_AppNavComponent_Host_0 */
/* unused harmony export AppNavComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_nav_component_scss_shim_ngstyle__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_components_app_nav_app_nav_component__ = __webpack_require__(73);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_AppNavComponent = [__WEBPACK_IMPORTED_MODULE_0__app_nav_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AppNavComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_14" /* ɵcrt */]({ encapsulation: 0,
    styles: styles_AppNavComponent, data: {} });
function View_AppNavComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](2, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 25, 'div', [['class', 'app-nav']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 22, 'div', [['class', 'wrapper']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 5, 'a', [['routerLink',
                'schedule'], ['routerLinkActive', 'active']], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 6).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](671744, [[2, 4]], 0, __WEBPACK_IMPORTED_MODULE_2__angular_router__["m" /* RouterLinkWithHref */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__angular_common__["i" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](1720320, null, 2, __WEBPACK_IMPORTED_MODULE_2__angular_router__["l" /* RouterLinkActive */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["n" /* ElementRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* Renderer2 */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]], { routerLinkActive: [0, 'routerLinkActive'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 1, { links: 1 }), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 2, { linksWithHrefs: 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['Schedule'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 5, 'a', [['routerLink', 'meals'],
            ['routerLinkActive', 'active']], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 13).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](671744, [[4, 4]], 0, __WEBPACK_IMPORTED_MODULE_2__angular_router__["m" /* RouterLinkWithHref */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__angular_common__["i" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](1720320, null, 2, __WEBPACK_IMPORTED_MODULE_2__angular_router__["l" /* RouterLinkActive */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["n" /* ElementRef */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* Renderer2 */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]], { routerLinkActive: [0, 'routerLinkActive'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 3, { links: 1 }), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 4, { linksWithHrefs: 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['Meals'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 5, 'a', [['routerLink', 'workouts'],
            ['routerLinkActive', 'active']], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (__WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 20).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](671744, [[6, 4]], 0, __WEBPACK_IMPORTED_MODULE_2__angular_router__["m" /* RouterLinkWithHref */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__angular_common__["i" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](1720320, null, 2, __WEBPACK_IMPORTED_MODULE_2__angular_router__["l" /* RouterLinkActive */], [__WEBPACK_IMPORTED_MODULE_2__angular_router__["k" /* Router */],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["n" /* ElementRef */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["N" /* Renderer2 */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["i" /* ChangeDetectorRef */]], { routerLinkActive: [0, 'routerLinkActive'] }, null), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 5, { links: 1 }), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_36" /* ɵqud */](603979776, 6, { linksWithHrefs: 1 }),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['Workouts'])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n  ']))], function (_ck, _v) {
        var currVal_2 = 'schedule';
        _ck(_v, 6, 0, currVal_2);
        var currVal_3 = 'active';
        _ck(_v, 7, 0, currVal_3);
        var currVal_6 = 'meals';
        _ck(_v, 13, 0, currVal_6);
        var currVal_7 = 'active';
        _ck(_v, 14, 0, currVal_7);
        var currVal_10 = 'workouts';
        _ck(_v, 20, 0, currVal_10);
        var currVal_11 = 'active';
        _ck(_v, 21, 0, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 6).target;
        var currVal_1 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 6).href;
        _ck(_v, 5, 0, currVal_0, currVal_1);
        var currVal_4 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 13).target;
        var currVal_5 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 13).href;
        _ck(_v, 12, 0, currVal_4, currVal_5);
        var currVal_8 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 20).target;
        var currVal_9 = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_31" /* ɵnov */](_v, 20).href;
        _ck(_v, 19, 0, currVal_8, currVal_9);
    });
}
function View_AppNavComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 1, 'app-nav', [], null, null, null, View_AppNavComponent_0, RenderType_AppNavComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_4__src_app_components_app_nav_app_nav_component__["a" /* AppNavComponent */], [], null, null)], null, null);
}
var AppNavComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_12" /* ɵccf */]('app-nav', __WEBPACK_IMPORTED_MODULE_4__src_app_components_app_nav_app_nav_component__["a" /* AppNavComponent */], View_AppNavComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=app-nav.component.ngfactory.js.map

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['[_nghost-%COMP%]{margin:-1px 0 0;display:block}.app-nav[_ngcontent-%COMP%]{background:#8022b0;text-align:center}.app-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:rgba(255,255,255,0.6);padding:15px 0;display:inline-block;min-width:150px;font-weight:500;font-size:16px;text-transform:uppercase;border-bottom:3px solid transparent}.app-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover, .app-nav[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{color:#fff;border-bottom-color:#fff}.wrapper[_ngcontent-%COMP%]{max-width:800px;width:96%;margin:0 auto}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29tcG9uZW50cy9hcHAtbmF2L2FwcC1uYXYuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvYmVuY3VycmllL0RvY3VtZW50cy9VbHRfQW5nL2FuZ3VsYXItcHJvLXNyYy9hbmd1bGFyLXByby1hcHAtc2VlZC1tYXN0ZXIvc3JjL2FwcC9jb21wb25lbnRzL2FwcC1uYXYvYXBwLW5hdi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=app-nav.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_AppHeaderComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_AppHeaderComponent_0;
/* unused harmony export View_AppHeaderComponent_Host_0 */
/* unused harmony export AppHeaderComponentNgFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_header_component_scss_shim_ngstyle__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_components_app_header_app_header_component__ = __webpack_require__(74);
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_AppHeaderComponent = [__WEBPACK_IMPORTED_MODULE_0__app_header_component_scss_shim_ngstyle__["a" /* styles */]];
var RenderType_AppHeaderComponent = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_14" /* ɵcrt */]({ encapsulation: 0,
    styles: styles_AppHeaderComponent, data: {} });
function View_AppHeaderComponent_1(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 3, 'div', [['class',
                'app-header__user-info']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n          '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 0, 'span', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.logoutUser() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        ']))], null, null);
}
function View_AppHeaderComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](2, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 9, 'div', [['class', 'app-header']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 6, 'div', [['class', 'wrapper']], null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 0, 'img', [['src',
                '/img/logo.svg']], null, null, null, null, null)),
        (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n        '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_11" /* ɵand */](16777216, null, null, 1, null, View_AppHeaderComponent_1)), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](16384, null, 0, __WEBPACK_IMPORTED_MODULE_2__angular_common__["k" /* NgIf */], [__WEBPACK_IMPORTED_MODULE_1__angular_core__["Z" /* ViewContainerRef */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["W" /* TemplateRef */]], { ngIf: [0, 'ngIf'] }, null), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n      '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_38" /* ɵted */](null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.user == null) ? null : _co.user.authenticated);
        _ck(_v, 8, 0, currVal_0);
    }, null);
}
function View_AppHeaderComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_1__angular_core__["_40" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_1__angular_core__["_17" /* ɵeld */](0, null, null, 1, 'app-header', [], null, null, null, View_AppHeaderComponent_0, RenderType_AppHeaderComponent)),
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["_15" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_3__src_app_components_app_header_app_header_component__["a" /* AppHeaderComponent */], [], null, null)], null, null);
}
var AppHeaderComponentNgFactory = __WEBPACK_IMPORTED_MODULE_1__angular_core__["_12" /* ɵccf */]('app-header', __WEBPACK_IMPORTED_MODULE_3__src_app_components_app_header_app_header_component__["a" /* AppHeaderComponent */], View_AppHeaderComponent_Host_0, { user: 'user' }, { logout: 'logout' }, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29tcG9uZW50cy9hcHAtaGVhZGVyL2FwcC1oZWFkZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29tcG9uZW50cy9hcHAtaGVhZGVyL2FwcC1oZWFkZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvYmVuY3VycmllL0RvY3VtZW50cy9VbHRfQW5nL2FuZ3VsYXItcHJvLXNyYy9hbmd1bGFyLXByby1hcHAtc2VlZC1tYXN0ZXIvc3JjL2FwcC9jb21wb25lbnRzL2FwcC1oZWFkZXIvYXBwLWhlYWRlci5jb21wb25lbnQudHMuQXBwSGVhZGVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbXBvbmVudHMvYXBwLWhlYWRlci9hcHAtaGVhZGVyLmNvbXBvbmVudC50cy5BcHBIZWFkZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IGNsYXNzPVwiYXBwLWhlYWRlclwiPlxuICAgICAgPGRpdiBjbGFzcz1cIndyYXBwZXJcIj5cbiAgICAgICAgPGltZyBzcmM9XCIvaW1nL2xvZ28uc3ZnXCIgLz5cbiAgICAgICAgPGRpdiBjbGFzcz1cImFwcC1oZWFkZXJfX3VzZXItaW5mb1wiICpuZ0lmPVwidXNlcj8uYXV0aGVudGljYXRlZFwiPlxuICAgICAgICAgIDxzcGFuIChjbGljayk9XCJsb2dvdXRVc2VyKClcIj48L3NwYW4+XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICIsIjxhcHAtaGVhZGVyPjwvYXBwLWhlYWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0lRO01BQUE7TUFBQSxnQkFBK0QsaURBQzdEO01BQUE7VUFBQTtRQUFBO1FBQUE7UUFBTTtVQUFBO1VBQUE7UUFBQTtRQUFOO01BQUEsZ0NBQW9DOzs7O29CQUw5QywyQ0FDSTtNQUFBO01BQUEsOEJBQXdCLDZDQUN0QjthQUFBO1VBQUEsMERBQXFCO01BQUEsaUJBQ25CO01BQUE7TUFBMkIsK0NBQzNCO1VBQUEsaUVBQUE7VUFBQTtVQUFBLGVBRU0sNkNBQ0Y7VUFBQSxhQUNGOztJQUppQztJQUFuQyxXQUFtQyxTQUFuQzs7OztvQkNKUjtNQUFBO2FBQUE7VUFBQTs7OzsifQ==
//# sourceMappingURL=app-header.component.ngfactory.js.map

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var styles = ['.app-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #c1cedb;padding:15px 0;text-align:center}.app-header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:inline-block}.app-header__user-info[_ngcontent-%COMP%]{position:absolute;top:16px;right:0;cursor:pointer}.app-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:url(/img/logout.svg) no-repeat;background-size:contain;width:24px;height:24px;display:block;opacity:0.4}.app-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:hover{opacity:0.9}.wrapper[_ngcontent-%COMP%]{max-width:800px;width:96%;margin:0 auto;position:relative}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29tcG9uZW50cy9hcHAtaGVhZGVyL2FwcC1oZWFkZXIuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvYmVuY3VycmllL0RvY3VtZW50cy9VbHRfQW5nL2FuZ3VsYXItcHJvLXNyYy9hbmd1bGFyLXByby1hcHAtc2VlZC1tYXN0ZXIvc3JjL2FwcC9jb21wb25lbnRzL2FwcC1oZWFkZXIvYXBwLWhlYWRlci5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=app-header.component.scss.shim.ngstyle.js.map

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROUTES */
/* unused harmony export firebaseConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthModule; });
var ROUTES = [
    {
        path: "auth",
        children: [
            { path: "", pathMatch: "full", redirectTo: "login" },
            { path: "login", loadChildren: "./login/login.module#LoginModule" },
            {
                path: "register",
                loadChildren: "./register/register.module#RegisterModule"
            }
        ]
    }
];
var firebaseConfig = {
    apiKey: "AIzaSyBIr0Mi8enCvavhiT5d-_x8J_NX8xkFAkM",
    authDomain: "fitness-app-ua-ffad7.firebaseapp.com",
    databaseURL: "https://fitness-app-ua-ffad7.firebaseio.com",
    projectId: "fitness-app-ua-ffad7",
    storageBucket: "fitness-app-ua-ffad7.appspot.com",
    messagingSenderId: "716655804729"
    // appId: "1:716655804729:web:b1c2c123573d0d2e90e8e8",
    // measurementId: "G-KJ6V9DJGR9"
};
var AuthModule = (function () {
    function AuthModule() {
    }
    return AuthModule;
}());

//# sourceMappingURL=auth.module.js.map

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROUTES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HealthModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_shared_guards_auth_guard__ = __webpack_require__(37);
// guards

var ROUTES = [
    {
        path: "schedule",
        canActivate: [__WEBPACK_IMPORTED_MODULE_0__auth_shared_guards_auth_guard__["a" /* AuthGuard */]],
        loadChildren: "./schedule/schedule.module#ScheduleModule"
    },
    {
        path: "meals",
        canActivate: [__WEBPACK_IMPORTED_MODULE_0__auth_shared_guards_auth_guard__["a" /* AuthGuard */]],
        loadChildren: "./meals/meals.module#MealsModule"
    },
    {
        path: "workouts",
        canActivate: [__WEBPACK_IMPORTED_MODULE_0__auth_shared_guards_auth_guard__["a" /* AuthGuard */]],
        loadChildren: "./workouts/workouts.module#WorkoutsModule"
    }
];
var HealthModule = (function () {
    function HealthModule() {
    }
    return HealthModule;
}());

//# sourceMappingURL=health.module.js.map

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth_auth_service__ = __webpack_require__(4);



var AuthGuard = (function () {
    function AuthGuard(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuard.prototype.canActivate = function () {
        var _this = this;
        // we need to return a boolean, and we can use auth.service
        return this.authService.authState.map(function (user) {
            // if they are not authenticated we want to send them to the login
            if (!user) {
                // the result recieved was a null result
                _this.router.navigate(["/auth/login"]);
            } // double bang (!!) converts to a boolean, user object is true, null is false
            return !!user;
        });
    };
    AuthGuard.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["k" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__services_auth_auth_service__["a" /* AuthService */] }]; };
    return AuthGuard;
}());

//# sourceMappingURL=auth.guard.js.map

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MealsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angularfire2_database__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_shared_services_auth_auth_service__ = __webpack_require__(4);








var MealsService = (function () {
    function MealsService(store, db, authService) {
        var _this = this;
        this.store = store;
        this.db = db;
        this.authService = authService;
        // setup observable stream
        this.meals$ = this.db
            .list("meals/" + this.uid)
            .do(function (next) { return _this.store.set("meals", next); });
    }
    Object.defineProperty(MealsService.prototype, "uid", {
        // expose user id for string above
        get: function () {
            return this.authService.user.uid;
        },
        enumerable: true,
        configurable: true
    });
    // get the key from the router. We are using this for the meal component for editing meals
    // lookup id from the store
    MealsService.prototype.getMeal = function (key) {
        if (!key)
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].of({});
        return this.store
            .select("meals")
            .filter(Boolean)
            .map(function (meals) { return meals.find(function (meal) { return meal.$key === key; }); });
    };
    MealsService.prototype.addMeal = function (meal) {
        return this.db.list("meals/" + this.uid).push(meal);
    };
    MealsService.prototype.updateMeal = function (key, meal) {
        return this.db.object("meals/" + this.uid + "/" + key).update(meal);
    };
    // pass through the key to firebase to remove the meal
    MealsService.prototype.removeMeal = function (key) {
        return this.db.list("meals/" + this.uid).remove(key);
    };
    MealsService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1_store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_0_angularfire2_database__["a" /* AngularFireDatabase */] }, { type: __WEBPACK_IMPORTED_MODULE_7__auth_shared_services_auth_auth_service__["a" /* AuthService */] }]; };
    return MealsService;
}());

//# sourceMappingURL=meals.service.js.map

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_do__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angularfire2_auth__ = __webpack_require__(109);



var AuthService = (function () {
    function AuthService(store, 
        // introduce angular fire authentication and database
        af) {
        var _this = this;
        this.store = store;
        this.af = af;
        this.auth$ = this.af.authState.do(function (next) {
            // if no user set value of user to null
            if (!next) {
                _this.store.set("user", null);
                // then exit function
                return;
            }
            // update user in the store
            var user = {
                email: next.email,
                uid: next.uid,
                authenticated: true
            };
            // set user in the store
            _this.store.set("user", user);
        });
    }
    Object.defineProperty(AuthService.prototype, "user", {
        // used in our meals service, this allows us to return user information
        get: function () {
            return this.af.auth.currentUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "authState", {
        // helper function for our auth.guard
        get: function () {
            return this.af.authState;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.createUser = function (email, password) {
        return this.af.auth.createUserWithEmailAndPassword(email, password);
    };
    AuthService.prototype.loginUser = function (email, password) {
        return this.af.auth.signInWithEmailAndPassword(email, password);
    };
    AuthService.prototype.logoutUser = function () {
        return this.af.auth.signOut();
    };
    AuthService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0_store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_2_angularfire2_auth__["a" /* AngularFireAuth */] }]; };
    return AuthService;
}());

//# sourceMappingURL=auth.service.js.map

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkoutsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angularfire2_database__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_shared_services_auth_auth_service__ = __webpack_require__(4);








var WorkoutsService = (function () {
    function WorkoutsService(store, db, authService) {
        var _this = this;
        this.store = store;
        this.db = db;
        this.authService = authService;
        // setup observable stream
        this.workouts$ = this.db
            .list("workouts/" + this.uid)
            .do(function (next) { return _this.store.set("workouts", next); });
    }
    Object.defineProperty(WorkoutsService.prototype, "uid", {
        // expose user id for string above
        get: function () {
            return this.authService.user.uid;
        },
        enumerable: true,
        configurable: true
    });
    // get the key from the router. We are using this for the workout component for editing workouts
    // lookup id from the store
    WorkoutsService.prototype.getWorkout = function (key) {
        if (!key)
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].of({});
        return this.store
            .select("workouts")
            .filter(Boolean)
            .map(function (workouts) {
            return workouts.find(function (workout) { return workout.$key === key; });
        });
    };
    WorkoutsService.prototype.addWorkout = function (workout) {
        return this.db.list("workouts/" + this.uid).push(workout);
    };
    WorkoutsService.prototype.updateWorkout = function (key, workout) {
        return this.db.object("workouts/" + this.uid + "/" + key).update(workout);
    };
    // pass through the key to firebase to remove the workout
    WorkoutsService.prototype.removeWorkout = function (key) {
        return this.db.list("workouts/" + this.uid).remove(key);
    };
    WorkoutsService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1_store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_0_angularfire2_database__["a" /* AngularFireDatabase */] }, { type: __WEBPACK_IMPORTED_MODULE_7__auth_shared_services_auth_auth_service__["a" /* AuthService */] }]; };
    return WorkoutsService;
}());

//# sourceMappingURL=workouts.service.js.map

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduleService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angularfire2_database__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_do__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_withLatestFrom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_shared_services_auth_auth_service__ = __webpack_require__(4);










var ScheduleService = (function () {
    function ScheduleService(store, authService, db) {
        var _this = this;
        this.store = store;
        this.authService = authService;
        this.db = db;
        this.date$ = new __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__["BehaviorSubject"](new Date());
        this.section$ = new __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__["Subject"]();
        this.itemList$ = new __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__["Subject"]();
        this.items$ = this.itemList$
            .withLatestFrom(this.section$)
            .map(function (_a) {
            var items = _a[0], section = _a[1];
            var id = section.data.$key;
            var defaults = {
                workouts: null,
                meals: null,
                section: section.section,
                timestamp: new Date(section.day).getTime()
            };
            var payload = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (id ? section.data : defaults), items);
            if (id) {
                return _this.updateSection(id, payload);
            }
            else {
                return _this.createSection(payload);
            }
        });
        this.selected$ = this.section$.do(function (next) { return _this.store.set("selected", next); });
        this.list$ = this.section$
            .map(function (value) { return _this.store.value[value.type]; })
            .do(function (next) { return _this.store.set("list", next); });
        this.schedule$ = this.date$
            .do(function (next) { return _this.store.set("date", next); })
            .map(function (day) {
            // we need a start and end property to search firebase for timestamps
            var startAt = new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime();
            var endAt = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1).getTime() - 1;
            return { startAt: startAt, endAt: endAt };
        })
            .switchMap(function (_a) {
            var startAt = _a.startAt, endAt = _a.endAt;
            return _this.getSchedule(startAt, endAt);
        })
            .map(function (data) {
            var mapped = {};
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var prop = data_1[_i];
                if (!mapped[prop.section]) {
                    mapped[prop.section] = prop;
                }
            }
            return mapped;
        })
            .do(function (next) { return _this.store.set("schedule", next); });
    }
    Object.defineProperty(ScheduleService.prototype, "uid", {
        get: function () {
            return this.authService.user.uid;
        },
        enumerable: true,
        configurable: true
    });
    ScheduleService.prototype.updateItems = function (items) {
        this.itemList$.next(items);
    };
    ScheduleService.prototype.updateDate = function (date) {
        this.date$.next(date);
    };
    ScheduleService.prototype.selectSection = function (event) {
        this.section$.next(event);
    };
    ScheduleService.prototype.createSection = function (payload) {
        return this.db.list("schedule/" + this.uid).push(payload);
    };
    ScheduleService.prototype.updateSection = function (key, payload) {
        return this.db.object("schedule/" + this.uid + "/" + key).update(payload);
    };
    ScheduleService.prototype.getSchedule = function (startAt, endAt) {
        // request info from firebase
        return this.db.list("schedule/" + this.uid, {
            query: {
                orderByChild: "timestamp",
                startAt: startAt,
                endAt: endAt
            }
        });
    };
    ScheduleService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2_store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_9__auth_shared_services_auth_auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_1_angularfire2_database__["a" /* AngularFireDatabase */] }]; };
    return ScheduleService;
}());

//# sourceMappingURL=schedule.service.js.map

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./login/login.module.ngfactory": [
		138,
		4
	],
	"./meals/meals.module.ngfactory": [
		141,
		2
	],
	"./register/register.module.ngfactory": [
		139,
		3
	],
	"./schedule/schedule.module.ngfactory": [
		140,
		0
	],
	"./workouts/workouts.module.ngfactory": [
		142,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 54;

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_pluck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_distinctUntilChanged__);


// rxjs


var state = {
    user: undefined,
    meals: undefined,
    selected: undefined,
    list: undefined,
    schedule: undefined,
    date: undefined,
    workouts: undefined
};
var Store = (function () {
    function Store() {
        this.subject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](state);
        this.store = this.subject.asObservable().distinctUntilChanged();
    }
    Object.defineProperty(Store.prototype, "value", {
        get: function () {
            return this.subject.value;
        },
        enumerable: true,
        configurable: true
    });
    Store.prototype.select = function (name) {
        return this.store.pluck(name);
    };
    Store.prototype.set = function (name, state) {
        this.subject.next(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.value, (_a = {}, _a[name] = state, _a)));
        var _a;
    };
    return Store;
}());

//# sourceMappingURL=store.js.map

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_shared_services_auth_auth_service__ = __webpack_require__(4);




var AppComponent = (function () {
    function AppComponent(store, router, authService) {
        this.store = store;
        this.router = router;
        this.authService = authService;
    }
    AppComponent.prototype.ngOnInit = function () {
        // access the observable we setup from the service
        this.subcription = this.authService.auth$.subscribe();
        // reactive approach to select user from store.
        this.user$ = this.store.select("user");
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.subcription.unsubscribe();
    };
    AppComponent.prototype.onLogout = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.logoutUser()];
                    case 1:
                        _a.sent();
                        // redirect back to login after this runs.
                        this.router.navigate(["/auth/login"]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2_store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_router__["k" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_3__auth_shared_services_auth_auth_service__["a" /* AuthService */] }]; };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppNavComponent; });
var AppNavComponent = (function () {
    function AppNavComponent() {
    }
    AppNavComponent.ctorParameters = function () { return []; };
    return AppNavComponent;
}());

//# sourceMappingURL=app-nav.component.js.map

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);

var AppHeaderComponent = (function () {
    function AppHeaderComponent() {
        this.logout = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["p" /* EventEmitter */]();
    }
    AppHeaderComponent.prototype.logoutUser = function () {
        this.logout.emit();
    };
    return AppHeaderComponent;
}());

//# sourceMappingURL=app-header.component.js.map

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_meals_meals_service__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_workouts_workouts_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_schedule_schedule_service__ = __webpack_require__(43);
// services



var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__services_meals_meals_service__["a" /* MealsService */], __WEBPACK_IMPORTED_MODULE_1__services_workouts_workouts_service__["a" /* WorkoutsService */], __WEBPACK_IMPORTED_MODULE_2__services_schedule_schedule_service__["a" /* ScheduleService */]]
        };
    };
    return SharedModule;
}());

//# sourceMappingURL=shared.module.js.map

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_auth_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__guards_auth_guard__ = __webpack_require__(37);
// services

//guards

var SharedModule = (function () {
    function SharedModule() {
    }
    // We create a property to avoid duplicate instances
    // See shared module for invocation.
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule,
            providers: [
                // This is done here because it would be called twice from NgModule decorator
                __WEBPACK_IMPORTED_MODULE_0__services_auth_auth_service__["a" /* AuthService */],
                __WEBPACK_IMPORTED_MODULE_1__guards_auth_guard__["a" /* AuthGuard */]
            ]
        };
    };
    return SharedModule;
}());

//# sourceMappingURL=shared.module.js.map

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80);
module.exports = __webpack_require__(81);


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflect_metadata__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflect_metadata___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflect_metadata__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngfactory_src_app_app_module_ngfactory__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__(22);




if (true) {
    __WEBPACK_IMPORTED_MODULE_1__angular_core__["_3" /* enableProdMode */]();
}
__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["j" /* platformBrowser */]().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_2__ngfactory_src_app_app_module_ngfactory__["a" /* AppModuleNgFactory */]);
//# sourceMappingURL=main.js.map

/***/ })

},[79]);


// WEBPACK FOOTER //
// app.js